<div class="dashboard-container">
    <main class="dashboard-content">
        <!-- Hero Section -->
        <section class="hero-section">


            <div class="hero-banner flex flex-row flex-wrap">


                <div class="flex-1 ">
                    <div class="gradient-overlay"></div>

                    <div class="geometric-pattern">
                        <div class="pattern-layer pattern-layer-1"></div>
                        <div class="pattern-layer pattern-layer-2"></div>
                        <div class="pattern-layer pattern-layer-3"></div>
                    </div>

                    <div class="particles-container">
                        <div class="particle" *ngFor="let _ of particleSlots; index as i; trackBy: particleTrackByIndex"
                            [style.animation-delay.s]="i * 0.8"></div>
                    </div>

                    <div class="chemical-formulas">
                        <div class="formula formula-1">H₂SO₄</div>
                        <div class="formula formula-2">C₆H₁₂O₆</div>
                        <div class="formula formula-3">NaCl</div>
                        <div class="formula formula-4">CH₄</div>
                        <div class="formula formula-5">H₂O</div>
                        <div class="formula formula-6">CO₂</div>
                    </div>

                    <div class="hexagon-grid">
                        <div class="hexagon" *ngFor="let _ of hexSlots; index as i; trackBy: trackByIndex"
                            [style.animation-delay.s]="i * 0.3"></div>
                    </div>
                    <div class="banner-content flex-1">
                        <div class="banner-text">
                            <div class="hero-main-content">

                                <div class="title-and-features">
                                    <div class="title-section">
                                        <h1 class="hero-main-title">
                                            Valence Chemical Operations Hub
                                        </h1>
                                    </div>
                                </div>

                                <!-- Integrated Animated Features -->
                                <div class="integrated-features ">
                                    <div class="feature-display" *ngFor="let feature of heroFeatures; let i = index"
                                        [class.active]="currentFeatureIndex === i"
                                        [@slideUpFade]="currentFeatureIndex === i ? 'visible' : 'hidden'">
                                        <div class="feature-content">
                                            <div class="feature-icon-title">
                                                <mat-icon class="feature-icon">{{ feature.icon }}</mat-icon>
                                                <h3 class="feature-name">{{ feature.title }}</h3>
                                            </div>
                                            <p class="feature-description">
                                                {{ feature.detailedDescription }}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div> <!-- /.hero-main-content -->
                        </div>
                    </div>
                </div>

                <app-pad-drillout-form class="drillout-form flex-1 flex-wrap"
                    (filtersChange)="onFilters($event)"></app-pad-drillout-form>


            </div>


            <div class="floating-molecule">
                <img src="assets/images/chemical-shape.webp" alt="Benzene Molecular Structure"
                    class="molecule-graphic-floating" />
            </div>
        </section>

        <button class="export-pdf-btn" mat-raised-button color="primary" (click)="exportToPDF()"
            [disabled]="!newFilters.drillOutTemplateId || isExporting" *ngIf="newFilters.drillOutTemplateId">
            <mat-icon>picture_as_pdf</mat-icon>
            <span *ngIf="!isExporting">Export Report to PDF</span>
            <span *ngIf="isExporting">Generating PDF...</span>
        </button>
        <kendo-pdf-export #pdf paperSize="A3" [landscape]="true" [scale]="pdfScale" [forcePageBreak]="'.chart-page'"
            [keepTogether]="'.chart-row'" [repeatHeaders]="true"
            [margin]="{ top: '0.5cm', left: '0.5cm', right: '0.5cm', bottom: '0.5cm' }">

            <ng-container *ngIf="newFilters.drillOutTemplateId">
                <div class="pdf-content">

                    <header class="pdf-section-header" *ngIf="isExporting">
                        <h2>Drilling Operations Report</h2>
                        <p class="report-date">Generated: {{ currentDate | date:'medium' }}</p>
                    </header>

                    <section class="charts-dashboard-section">
                        <div class="charts-grid">
                            <ng-container *ngFor="let c of cards">
                                <article class="chart-card">
                                    <header class="card-header">
                                        <div class="card-title-section">
                                            <h3 class="card-title">{{ c.title }}</h3>
                                            <p class="card-subtitle">{{ c.subtitle }}</p>
                                        </div>
                                    </header>

                                    <div class="card-body" style="max-height: 500px; overflow: auto;">
                                        <aggregated-table [config]="c.config">
                                        </aggregated-table>
                                    </div>
                                </article>
                            </ng-container>
                        </div>


                            <div class="chart-row charts-grid">
                                <home-page-chart [hideMenu]="true" [extraFilters]="newFilters" [chartOptionMenu]="chartOptions"
                                    [defaultRequest]="'4c728258-a63d-40b9-9f56-c06c70c40bff'" [scrollable]="true">
                                </home-page-chart>
                            </div>

                            <div class="chart-row charts-grid">
                                <home-page-chart [hideMenu]="true" [extraFilters]="newFilters" [chartOptionMenu]="chartOptions"
                                    [defaultRequest]="'7400aa09-663b-4c59-8604-58122a48d43d'" [scrollable]="true">
                                </home-page-chart>
                            </div>

                            <div class="chart-row charts-grid chart-card">
                                <home-page-chart [hideMenu]="true" [extraFilters]="newFilters" [chartOptionMenu]="chartOptions"
                                    [defaultRequest]="'3ff83f90-a111-4024-9e00-5b29b665ab8b'" [scrollable]="true">
                                </home-page-chart>
                            </div>

                            <div class="chart-row charts-grid ">
                                <home-page-chart [hideMenu]="true"  [extraFilters]="newFilters" [chartOptionMenu]="chartOptions"
                                    [defaultRequest]="'ed405b64-0bb8-4660-a1fe-5ba3a696e684'" [scrollable]="true">
                                </home-page-chart>
                            </div>
                    </section>
                </div>

            </ng-container>

        </kendo-pdf-export>

        <ng-container *ngIf="newFilters.drillOutTemplateId">
            <div class="data-grid-section">
                <home-page-table [hideMenu]="true" [extraFilters]="newFilters" [tableOptionMenu]="tableOptions"
                    [defaultRequest]="tableOptions[0].requestId">
                </home-page-table>
            </div>
        </ng-container>
    </main>
</div>